import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalyticsHelpers } from '../useAnalyticsHelpers';
import { useAppSelector } from '../app/hooks';

function useTracking(): void {
  const { pathname } = useLocation();
  const { setFWALayerPageContentIds, getCurrentPage, getCurrentApplicationStep } = useAnalyticsHelpers();

  const { filters: storedFilters } = useAppSelector((state) => state.filters);
  const { motionType } = storedFilters;

  useEffect(() => {
    const applicationStep = getCurrentPage(pathname);
    const isRootPage = applicationStep === 'root page';

    setFWALayerPageContentIds(
      isRootPage ? 'select movement' : `${motionType}/${applicationStep}`,
      isRootPage ? 0 : getCurrentApplicationStep(pathname),
    );
  }, [pathname, motionType]);
}

export default useTracking;
